export const es = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'INDIVIDUAL-USER-MANAGEMENT': {
    TITLE: 'Gestión de Usuari@s',
    TABLE: {
      TITLE: 'Usuari@s',
      FILTERS: {
        SEARCH: 'Buscar',
        SEARCH_PLACEHOLDER: 'Buscar por nombre u ocupación',
        COUNTRY: 'País',
        STATE: 'Estado/Provincia',
        ENABLED: 'Habilitado',
      },
      HEADER: {
        ID: 'ID',
        PHOTO: 'Foto de Perfil',
        NAME: 'Nombre y Apellido',
        BUSINESS_NAME: 'Ocupación/Oficio',
        MAIN_TAG: 'Ocupación',
        AGE: 'Edad',
        GENDER: 'Género',
        EMAIL: 'Email',
        PHONE: 'Teléfono',
        CITY: 'Ciudad',
        STATE: 'Estado / Provincia',
        COUNTRY: 'País',
        ENABLED: 'Habilitado',
        CREATED_AT: 'Fecha de creación',
        LAST_LOGIN: 'Último acceso',
        DAYS_TO_FIRST_APPLY: 'Días hasta 1ª aplicación',
        TOTAL_APPLICATIONS: 'Total aplicaciones',
        SELECTED_APPLICATIONS: 'Aplicaciones seleccionadas',
        ACTIONS: 'Acciones',
      },
      TOOLTIP: { DELETE: 'Eliminar usuari@' },
      NO_DATA: 'No hay datos disponibles',
    },
    SUCCESS: {
      HEADER: 'Éxito',
      USER_UPDATED: 'Usuari@ actualizad@ correctamente.',
      USER_DELETED: 'Usuari@ eliminad@ correctamente.',
    },
    DELETE_CONFIRMATION: {
      TITLE: 'Confirmar eliminación',
      MESSAGE: '¿Está segur@ de que desea eliminar a usuari@ {{name}}? Esta acción no se puede deshacer.',
    },
    ERRORS: {
      GENERIC_ERROR: 'Ha ocurrido un error',
      USER_UPDATE_FAILED: 'Error al actualizar usuari@',
    },
  },
};

export default es;
